import { LogIn } from "@/pages/RegistrationPage/Components/LogIn";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const logInPageRoute: RouteProps = {
  path: appRouterPaths.logIn,
  element: <LogIn />,
};
